import { Link, Outlet, createFileRoute } from '@tanstack/react-router'

import brandCoin from '@/assets/brand/brand-coin.png'

/**
 * The frame for a page anyone may open without signing in
 * (routes/courses.ts's `publicRoutes`): the brand, and the page under it.
 *
 * No `beforeLoad` on purpose — this layout is the way AROUND the app's auth
 * gate, not a second gate. No AppShell either: its rail and member card make
 * signed-in requests. The page owns its `<main>`, so the router's default
 * error page, which brings its own, never nests one inside another.
 *
 * The brand links home: a member lands in the app, anyone else is sent to
 * sign in by the app layout's own guard.
 */
function PublicLayout() {
  return (
    <div className="min-h-dvh bg-background text-foreground">
      <header className="mx-auto flex w-full max-w-3xl items-center px-shell-x py-5">
        <Link
          to="/"
          className="flex min-h-11 items-center gap-3 rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
        >
          {/* The brand coin (`5890:2`); Figma 34 → 36 (4-grid). */}
          <img src={brandCoin} alt="" className="size-9" />
          <span className="text-h-l">MoneyMitra</span>
        </Link>
      </header>
      <Outlet />
    </div>
  )
}

export const Route = createFileRoute('/_public')({
  component: PublicLayout,
})
